import StoreInventoryList from './StoreInventoryList.js';

const StoreModal = () => {
  let modalIsOpen = false;
  let addressData = '';
  let storeList = [];
  let sortedStoreList = [];
  let loadMoreClicked = false;
  let numberOfStores = '';
  let isLoading = false;
  let firstTimeOpened = false;
  let formError = false;
  let successfulResponse = false;
  let errorMessage = '';

  const inventoryThreshold = document.querySelector('[data-inventory-threshold]');
  const inventoryThresholdNumber = Number(inventoryThreshold.dataset.inventoryThreshold);
  let storedLatitude = false;
  let storedLongitude = false;
  let searchedOnce = false;
  let radiusData = 25;
  let savedRadiusData = 25;

  const API_KEY =
    window.location.origin.indexOf('windsorstore.com') > -1
      ? 'AIzaSyAeTZw-ttseoKrNwCEQOjqLEQkX_JFmeuY'
      : 'AIzaSyCQt8mUN8zA2y1ps1UzIPq9Pwg8c9qnkY4';

  let modalContainer;
  let modalElement;

  const updateSortedStoreList = () => {
    const storeListInventory = [];
    const storeListZeroInventory = [];

    // Sort through store list and prioritize stores with inventory above stores with 0 inventory.
    storeList.forEach((store) => {
      if (store.quantity - inventoryThresholdNumber <= 0) {
        store.quantity = 0;
        storeListZeroInventory.push(store);
      } else {
        storeListInventory.push(store);
      }
    });

    numberOfStores = storeListInventory.length;

    // Merge both arrays so stores with availability show before stores with 0 inventory.
    sortedStoreList = storeListInventory.concat(storeListZeroInventory);

    render();
  };

  const setDynamicHeight = () => {
    let el = document.querySelector('.StoreInventoryModal__container');

    if (!el) {
      return;
    }

    const modalHeight = document.querySelector('.StoreInventoryModal__container').clientHeight;
    document.querySelector('.StoreInventory').style.height = `${modalHeight}px`;
  };

  const closeModal = () => {
    modalIsOpen = false;
    if (window.innerWidth <= 767) {
      document.querySelector('.StoreInventory').style.height = 'auto';
    }
    render();
  };

  const submitSearch = (e) => {
    e.preventDefault();
  };

  const clickLoadMore = () => {
    loadMoreClicked = true;
    render();
  };

  const clearLocalStorage = () => {
    window.localStorage.removeItem('userLatLong');
    window.localStorage.removeItem('userAddress');
  };

  const getGeoLocation = () => {
    successfulResponse = false;
    formError = false;
    errorMessage = '';

    if (addressData === '') {
      errorMessage = 'Oops! Some fields are missing information. Please complete your info and click "GO".';
      formError = true;
      render();
      return;
    }

    const encodedAddress = encodeURI(addressData);
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${API_KEY}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        const location = data.results[0].geometry.location;
        storedLatitude = location.lat;
        storedLongitude = location.lng;
        window.localStorage.setItem(
          'userLatLong',
          JSON.stringify({
            latitude: location.lat,
            longitude: location.lng,
          }),
        );
        window.localStorage.setItem('userAddress', addressData);
        firstTimeOpened = true;
        fetchStores(location.lat, location.lng, false);
      })
      .catch((error) => {
        console.error('Error:', error);
        errorMessage =
          "Oops! We couldn't recognize that address. Please make sure to enter Zip Code or City and State.";
        formError = true;
        clearLocalStorage();
        render();
      });
  };

  const fetchStores = (latitude, longitude, isGeoLocation) => {
    isLoading = true;
    render();

    storedLatitude = latitude;
    storedLongitude = longitude;
    savedRadiusData = radiusData;

    const skuAttribute = document.querySelector('[data-sku]').getAttribute('data-sku');
    const url = `https://inventory-lookup-service.wndsr.io/store_inventory_lookup?lat=${latitude}&lng=${longitude}&sku=${skuAttribute}&range=${radiusData}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        searchedOnce = true;

        const setSuccessStates = () => {
          storeList = data;
          successfulResponse = true;
          firstTimeOpened = true;
          updateSortedStoreList();
        };

        if (isGeoLocation && firstTimeOpened) {
          isLoading = false;
          setSuccessStates();
        } else {
          setTimeout(() => {
            isLoading = false;
            setSuccessStates();
          }, 700);
        }

        if (data.length === 0) {
          clearLocalStorage();
        }

        if (window.innerWidth <= 767 && data.length > 0) {
          setDynamicHeight();
        }
      })
      .catch((error) => {
        isLoading = false;
        formError = true;
        clearLocalStorage();
        console.error('Error:', error);
        render();
      });
  };

  const showLocation = (position) => {
    storedLatitude = position.coords.latitude;
    storedLongitude = position.coords.longitude;
    window.localStorage.setItem(
      'userLatLong',
      JSON.stringify({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      }),
    );
    firstTimeOpened = true;

    fetchStores(position.coords.latitude, position.coords.longitude, true);
  };

  const blockLocation = (error) => {
    console.log(error);
    isLoading = false;
    render();
  };

  const getLatLong = () => {
    successfulResponse = false;
    formError = false;
    isLoading = true;
    errorMessage = '';
    render();

    navigator.geolocation.getCurrentPosition(showLocation, blockLocation);
  };

  // Initialize component
  const init = () => {
    let latLong = window.localStorage.getItem('userLatLong');
    let address = window.localStorage.getItem('userAddress');

    if (address) {
      addressData = address;
    }

    if (latLong && !firstTimeOpened) {
      let latLongObj = JSON.parse(latLong);
      fetchStores(latLongObj.latitude, latLongObj.longitude, false);
    }
  };

  const render = () => {
    if (!modalContainer) return;

    modalContainer.innerHTML = '';

    if (modalIsOpen) {
      modalElement = document.createElement('div');
      modalElement.className = 'StoreInventoryModal__container';

      if (isLoading) {
        const loader = document.createElement('div');
        loader.className = 'StoreInventoryModal__loader';
        const loadingImg = document.createElement('img');
        loadingImg.src = 'https://cdn.shopify.com/s/files/1/0070/8853/7651/files/Windsor_LoadingHeart.gif?63611';
        loadingImg.alt = 'loading';
        loader.appendChild(loadingImg);
        modalElement.appendChild(loader);
      }

      // Close icon
      const closeIcon = document.createElement('div');
      closeIcon.className = 'CloseIcon';
      closeIcon.addEventListener('click', closeModal);
      for (let i = 0; i < 4; i++) {
        const span = document.createElement('span');
        closeIcon.appendChild(span);
      }

      // Title
      const title = document.createElement('p');
      title.className = 'StoreInventoryModal__title';
      title.textContent = 'Check Windsor Store Locations';

      // Error message
      const errorP = document.createElement('p');
      errorP.className = 'StoreInventoryModal__error';
      errorP.textContent = errorMessage;

      // Form
      const form = document.createElement('form');
      form.className = 'StoreInventoryModal__form';
      form.addEventListener('submit', submitSearch);

      const row1 = document.createElement('div');
      row1.className = 'StoreInventoryModal__row';

      const input = document.createElement('input');
      input.className = `StoreInventoryModal__form-search ${
        formError ? 'StoreInventoryModal__form-search--error' : ''
      }`;
      input.placeholder = 'ZIP code or City & State';
      input.value = addressData;
      input.addEventListener('input', (e) => {
        addressData = e.target.value;
      });

      const select = document.createElement('select');
      select.className = 'StoreInventoryModal__form-radius';

      // Populate options first
      ['25', '50', '100', '200'].forEach((miles) => {
        const option = document.createElement('option');
        option.value = miles;
        option.textContent = `${miles} miles`;
        select.appendChild(option);
      });

      select.value = window.localStorage.getItem('userLatLong') ? savedRadiusData : radiusData;

      select.addEventListener('change', (e) => {
        radiusData = Number(e.target.value);
        savedRadiusData = radiusData;
      });

      const button = document.createElement('button');
      button.className = 'Button Button--primary';
      button.type = 'submit';
      button.textContent = 'Go';
      button.addEventListener('click', getGeoLocation);

      row1.appendChild(input);
      row1.appendChild(select);
      row1.appendChild(button);

      const row2 = document.createElement('div');
      row2.className = 'StoreInventoryModal__row';

      const currentLocationSpan = document.createElement('span');
      currentLocationSpan.className = 'StoreInventoryModal__link-text';
      currentLocationSpan.textContent = 'Use Current Location';
      currentLocationSpan.addEventListener('click', getLatLong);

      row2.appendChild(currentLocationSpan);

      form.appendChild(row1);
      form.appendChild(row2);

      modalElement.appendChild(closeIcon);
      modalElement.appendChild(title);
      modalElement.appendChild(errorP);
      modalElement.appendChild(form);

      if (numberOfStores >= 0 && sortedStoreList && sortedStoreList.length > 0) {
        const disclaimerBar = document.createElement('div');
        disclaimerBar.className = 'StoreInventoryModal__disclaimer-bar';
        disclaimerBar.textContent = "Product availability changes frequently and isn't guaranteed.";
        modalElement.appendChild(disclaimerBar);
      }

      if (sortedStoreList && sortedStoreList.length > 0) {
        const locationCount = document.createElement('div');
        locationCount.className = 'StoreInventoryModal__location-count';
        locationCount.textContent = `${numberOfStores} Locations with this item`;
        modalElement.appendChild(locationCount);
      }

      if (successfulResponse && sortedStoreList && sortedStoreList.length <= 0) {
        const errorUnavailable = document.createElement('div');
        errorUnavailable.className = 'StoreInventoryModal__error-unavailable';
        errorUnavailable.textContent =
          "Oh no! This style isn't available in any nearby stores. Try expanding your distance for better results.";
        modalElement.appendChild(errorUnavailable);
      }

      if (sortedStoreList && sortedStoreList.length > 0) {
        const storesContainer = document.createElement('div');
        storesContainer.className = `StoreInventoryModal__stores ${
          loadMoreClicked ? 'StoreInventoryModal__stores--expanded' : ''
        }`;

        sortedStoreList.forEach((store, i) => {
          if (i < 3) {
            const storeDiv = document.createElement('div');
            storeDiv.className = `StoreInventoryList ${
              !loadMoreClicked && i === 2 ? 'StoreInventoryList__hide-border' : ''
            }`;

            const storeComponent = StoreInventoryList({
              lastIndex: sortedStoreList.length - 1,
              index: i,
              buttonClicked: loadMoreClicked,
              store: store,
            });

            storeDiv.appendChild(storeComponent);
            storesContainer.appendChild(storeDiv);
          } else if (loadMoreClicked) {
            const storeDiv = document.createElement('div');
            storeDiv.className = `StoreInventoryList ${
              i === sortedStoreList.length - 1 ? 'StoreInventoryList__hide-border' : ''
            }`;

            const storeComponent = StoreInventoryList({
              lastIndex: sortedStoreList.length - 1,
              index: i,
              buttonClicked: true,
              store: store,
            });

            storeDiv.appendChild(storeComponent);
            storesContainer.appendChild(storeDiv);
          }
        });

        if (!loadMoreClicked && sortedStoreList.length > 3) {
          const loadMoreButton = document.createElement('button');
          loadMoreButton.className = 'Button Button--secondary StoreInventoryModal__load-button';
          loadMoreButton.textContent = 'Load More Locations';
          loadMoreButton.addEventListener('click', clickLoadMore);
          storesContainer.appendChild(loadMoreButton);
        }

        modalElement.appendChild(storesContainer);
      }

      modalContainer.appendChild(modalElement);
    }
  };

  // Setup container and initial events
  modalContainer = document.createElement('div');

  // Check availability button event
  const checkAvailabilityBtn = document.querySelector('[data-check-availability]');
  if (checkAvailabilityBtn) {
    checkAvailabilityBtn.addEventListener('click', (e) => {
      e.stopImmediatePropagation();
      modalIsOpen = true;
      if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
          event: 'pdp_local_store_availability_click',
        });
      }

      // On mobile, push product detail section down when opening the search modal
      if (window.innerWidth <= 767) {
        setDynamicHeight();
      }
      render();
    });
  }

  // Variant change event
  document.addEventListener('variantChange', (event) => {
    event.stopImmediatePropagation();

    const modalOpen = document.querySelector('.StoreInventoryModal__container');

    if (!modalOpen && searchedOnce) {
      sortedStoreList = [];
      numberOfStores = 0;
      successfulResponse = false;
      window.localStorage.removeItem('userLatLong');
      window.localStorage.removeItem('userAddress');
      return;
    }

    if (storedLatitude && storedLongitude) {
      fetchStores(storedLatitude, storedLongitude, false);
    }
  });

  // Initialize
  init();

  return modalContainer;
};

const renderInventoryModal = (el) => {
  const storeModal = StoreModal();
  el.appendChild(storeModal);
};

export default () => {
  const el = document.querySelector('[data-store-inventory-modal]');
  if (el) {
    renderInventoryModal(el);
  }
};
